// Purpose: To handle the header functionality
document.addEventListener("DOMContentLoaded", function () {
  const featuresLink = document.getElementById("features-link");
  const appsLink = document.getElementById("apps-link");
  const resourcesLink = document.getElementById("resources-link");
  const apiLink = document.getElementById("api-link");

  const featuresMegaMenu = document.querySelector(".features-mega-menu");
  const appsMegaMenu = document.querySelector(".apps-mega-menu");
  const resourcesMegaMenu = document.querySelector(".resources-mega-menu");
  const apiMegaMenu = document.querySelector(".api-mega-menu");

  const integrations = document.querySelector(".integrations");
  const alerts = document.querySelector(".alerts");
  const orderManagement = document.querySelector(".order-management");

  const integrationApps = document.querySelector(".integration-apps");
  const orderManagementApps = document.querySelector(".order-management-apps");
  const alertApps = document.querySelector(".alert-apps");

  // Toggle the Integration Apps when the Integration Apps link is clicked
  integrations.addEventListener("click", function () {
    toggleIntegrationApps();
  });

  // Toggle the Alert Apps when the Alert Apps link is clicked
  alerts.addEventListener("click", function () {
    toggleAlertApps();
  });

  // Toggle the Order Management Apps when the Order Management Apps link is clicked
  orderManagement.addEventListener("click", function () {
    toggleOrderManagementApps();
  });

  //Toggles Features Mega Menu
  featuresLink.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent the default behavior of the link
    toggleFeaturesMegaMenu();
    hideAppsMegaMenu();
  });

  //Toggles Apps Mega Menu
  appsLink.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent the default behavior of the link
    toggleAppsMegaMenu();
    hideFeaturesMegaMenu();
  });

  //Toggles Resources Mega Menu
  resourcesLink.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent the default behavior of the link
    toggleResourcesMegaMenu();
  });

  //Toggles API Mega Menu
  apiLink.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent the default behavior of the link
    toggleApiMegaMenu();
  });

  // Hide the mega menus when the user clicks outside of the mega menus
  document.addEventListener("click", function (event) {
    const isFeaturesLink = event.target.closest("#features-link");
    const isAppsLink = event.target.closest("#apps-link");
    const isFeaturesMenu = event.target.closest(".features-mega-menu");
    const isAppsMenu = event.target.closest(".apps-mega-menu");
    const isResourcesLink = event.target.closest("#resources-link");
    const isResourcesMenu = event.target.closest(".resources-mega-menu");
    const isApiLink = event.target.closest("#api-link");
    const isApiMenu = event.target.closest(".api-mega-menu");

    if (
      !isFeaturesLink &&
      !isAppsLink &&
      !isFeaturesMenu &&
      !isAppsMenu &&
      !isResourcesLink &&
      !isResourcesMenu &&
      !isApiLink &&
      !isApiMenu
    ) {
      hideFeaturesMegaMenu();
      hideAppsMegaMenu();
      hideResourcesMegaMenu();
      hideApiMegaMenu();
    }
  });

  //Toggles the Features Mega Menu
  function toggleFeaturesMegaMenu() {
    featuresMegaMenu.classList.toggle("hidden");
    // Ensure the other mega menus are hidden when the features menu is toggled
    if (!featuresMegaMenu.classList.contains("hidden")) {
      hideAppsMegaMenu();
      hideResourcesMegaMenu();
      hideApiMegaMenu();
    }
  }

  //Toggles the Resources Mega Menu
  function toggleResourcesMegaMenu() {
    resourcesMegaMenu.classList.toggle("hidden");
    // Ensure the other mega menus are hidden when the resources menu is toggled
    if (!resourcesMegaMenu.classList.contains("hidden")) {
      hideFeaturesMegaMenu();
      hideAppsMegaMenu();
      hideApiMegaMenu();
    }
  }

  //Toggles the Apps Mega Menu
  function toggleAppsMegaMenu() {
    appsMegaMenu.classList.toggle("hidden");
    hideAllApps();
    // Ensure the other mega menus is hidden when the apps menu is toggled
    if (!appsMegaMenu.classList.contains("hidden")) {
      hideFeaturesMegaMenu();
      hideResourcesMegaMenu();
      hideApiMegaMenu();
    }
  }

  //Toggles the API Mega Menu
  function toggleApiMegaMenu() {
    apiMegaMenu.classList.toggle("hidden");
    // Ensure the other mega menus are hidden when the API menu is toggled
    if (!apiMegaMenu.classList.contains("hidden")) {
      hideFeaturesMegaMenu();
      hideAppsMegaMenu();
      hideResourcesMegaMenu();
    }
  }

  //Hides the Features Mega Menu
  function hideFeaturesMegaMenu() {
    featuresMegaMenu.classList.add("hidden");
  }

  //Hides the Apps Mega Menu
  function hideAppsMegaMenu() {
    appsMegaMenu.classList.add("hidden");
  }

  //Hides the Resources Mega Menu
  function hideResourcesMegaMenu() {
    resourcesMegaMenu.classList.add("hidden");
  }

  //Hides the API Mega Menu
  function hideApiMegaMenu() {
    apiMegaMenu.classList.add("hidden");
  }

  //Toggles the Integration Apps
  function toggleIntegrationApps() {
    if (integrationApps.classList.contains("hidden")) {
      integrationApps.classList.remove("hidden");
      orderManagementApps.classList.add("hidden");
      alertApps.classList.add("hidden");
    }
  }

  //Toggles the Order Management Apps
  function toggleOrderManagementApps() {
    if (orderManagementApps.classList.contains("hidden")) {
      orderManagementApps.classList.remove("hidden");
      integrationApps.classList.add("hidden");
      alertApps.classList.add("hidden");
    }
  }

  //Toggles the Alert Apps
  function toggleAlertApps() {
    if (alertApps.classList.contains("hidden")) {
      alertApps.classList.remove("hidden");
      integrationApps.classList.add("hidden");
      orderManagementApps.classList.add("hidden");
    }
  }

  //Hides all the Apps
  function hideAllApps() {
    integrationApps.classList.add("hidden");
    orderManagementApps.classList.add("hidden");
    alertApps.classList.add("hidden");
  }
});
